import { request } from '@/services/api/requests';
import { ENDPOINTS } from '@/services/endpoints';
import {
  HarvestFarmerStats,
  HarvestGrainContractTotal,
  HarvestGrainCount,
  HarvestGrainSignedPk,
  HarvestPlace,
  HarvestPlacesRegionStats,
  HarvestPlacesRegionStatsParams,
  HarvestRegionStats,
  RegionHarvestYearModel,
} from '../model';

export const getLandHarvest = async (
  year: string,
  regionCode?: string,
  plantType?: string,
) => {
  return await request<RegionHarvestYearModel[]>(
    ENDPOINTS.GET_LAND_HARVEST_LOADS,
    {
      params: { year, region_code: regionCode, plant_type: plantType },
    },
  ).then((res) => res.data);
};
export const getLandHarvestContract = async (
  year: string,
  regionCode?: string,
  plantType?: string,
) => {
  return await request<RegionHarvestYearModel[]>(
    ENDPOINTS.GET_LAND_HARVEST_CONTRACT,
    {
      params: { year, region_code: regionCode, plant_type: plantType },
    },
  ).then((res) => res.data);
};
export const getHarvestFarmerStats = async (
  year: string,
  regionCode?: string,
  plantType?: string,
) => {
  return await request<HarvestFarmerStats>(ENDPOINTS.GET_HARVEST_FARMER_STATS, {
    params: { year, region_code: regionCode, plant_type: plantType },
  }).then((res) => res.data);
};
export const getHarvestRegionStats = async (
  year: string,
  regionCode?: string,
  plantType?: string,
) => {
  return await request<HarvestRegionStats>(ENDPOINTS.GET_HARVEST_REGION_STATS, {
    params: { year, region_code: regionCode, plant_type: plantType },
  }).then((res) => res.data);
};

/** Maskanlar statistikasi. Nima qaytishi parametrlarga bog'liq:
 *  parametrsiz — viloyatlar, `regionCode` bilan — o'sha viloyat maskanlari,
 *  `type=organization` — klasterlar, unga `taxNumber` qo'shilsa — klaster maskanlari. */
export const getHarvestPlacesRegionStats = async ({
  year,
  regionCode,
  plantType,
  type,
  taxNumber,
}: HarvestPlacesRegionStatsParams) => {
  return await request<HarvestPlacesRegionStats>(
    ENDPOINTS.GET_HARVEST_PLACES_REGION_STATS,
    {
      params: {
        year,
        region_code: regionCode,
        plant_type: plantType,
        type,
        tax_number: taxNumber,
      },
    },
  ).then((res) => res.data);
};

/** Bitta qabul qilish maskani. `placeId` — 1-endpointdagi `regions[].id`. */
export const getHarvestPlace = async (
  year: string,
  placeId: string,
  plantType?: string,
) => {
  return await request<HarvestPlace>(ENDPOINTS.GET_HARVEST_PLACE_RETRIEVE, {
    params: { year, place_id: placeId, plant_type: plantType },
  }).then((res) => res.data);
};

export const getHarvestGrainCount = async (
  year: string,
  plantType?: string,
) => {
  return await request<HarvestGrainCount>(ENDPOINTS.GET_HARVEST_GRAIN_COUNT, {
    params: { year, plant_type: plantType },
  }).then((res) => res.data);
};

export const getHarvestGrainContractTotals = async (
  year: string,
  regionId?: string,
  plantType?: string,
) => {
  return await request<HarvestGrainContractTotal[]>(
    ENDPOINTS.GET_HARVEST_GRAIN_CONTRACT_TOTALS,
    {
      params: { year, region_id: regionId, plant_type: plantType },
    },
  ).then((res) => res.data);
};

export const getHarvestGrainSignedPk10ByRegion = async (
  year: string,
  regionCode?: string,
) => {
  const response = await request<HarvestGrainSignedPk[]>(
    ENDPOINTS.GET_HARVEST_GRAIN_SIGNED_PK10_BY_REGION,
    {
      params: { year, region_code: regionCode },
    },
  );

  return response.data;
};
